"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
/**
 * Representa a sequence para um Retailer ou Time
 * do retailer para efetuar o atendimento sequencial
 */
class SequenceSupport extends Parse.Object {
    constructor(attributes) {
        super('SequenceSupport', attributes);
    }
    get counter() {
        return this.get('counter');
    }
    set counter(value) {
        this.set('counter', value);
    }
    get retailer() {
        return this.get('retailer');
    }
    set retailer(value) {
        this.set('retailer', value);
    }
    get team() {
        return this.get('team');
    }
    set team(value) {
        this.set('team', value);
    }
}
exports.SequenceSupport = SequenceSupport;
Parse.Object.registerSubclass('SequenceSupport', SequenceSupport);
//# sourceMappingURL=SequenceSupport.js.map